// @flow
import React from 'react';

import { NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT } from 'Components/widgets/navigation/Navigation.constants';

type Props = {
  height: number,
};

export function NavigationLargeBackPanel({ height = 0 }: Props) {
  return (
    <div className="absolute inset-x-0 pointer-events-none top-full z-0">
      <div
        className="bg-white h-0 my-0 mx-auto max-w-site overflow-hidden pointer-events-none shadow transition-heights w-full"
        style={{
          height: `${String(height)}px`,
          maxHeight: NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT,
        }}
      />
    </div>
  );
}
